import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import AutoSuggestInput from 'auto-suggest-input-component';

class GooglePlacesSearchInput extends Component {
    constructor(props) {
        super(props);

        this._gmaps = window.google.maps;
        this._autocompleteService = new this._gmaps.places.AutocompleteService();
        this._geocoder = new this._gmaps.Geocoder();
        this._searchSuggestions = this._searchSuggestions.bind(this);
        this._onSuggestionSelect = this._onSuggestionSelect.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        if (this.props.focus) {
            this.refs.autosuggest.focus();
        }
    }

    _searchSuggestions(value, callback) {
        const {
            country,
            types,
            bounds
        } = this.props;
        const options = {
            input: value
        };
        const cityBounds = (bounds)
            ? bounds
            : (window.includeACBounds)
                ? new this._gmaps.LatLngBounds(
                    new this._gmaps.LatLng(window.sw_lat, window.sw_lng),
                    new this._gmaps.LatLng(window.ne_lat, window.ne_lng)
                )
                : null;

        if (types) {
            options.types = types;
        }

        if (cityBounds) {
            options.bounds = cityBounds;
        } else {
            const circle = new this._gmaps.Circle({
                center: {
                    lat: 0,
                    lng: 0
                },
                radius: 10000
            });

            options.bounds = circle.getBounds();
        }

        if (country) {
            options.componentRestrictions = {
                country
            };
        }

        this._autocompleteService.getPlacePredictions(
            options,
            suggestions => {
                if (callback) {
                    callback(suggestions);
                }
            }
        );
    }

    _onSuggestionSelect(suggestion) {
        const {
            placesPlaceId,
            label
        } = suggestion;

        if (suggestion.location) {
            this.props.onSuggestionSelect(suggestion);
        } else {
            this._geocoder.geocode(
                (placesPlaceId) ? {placeId: placesPlaceId} : {address: label},
                (results, status) => {
                    if (status !== this._gmaps.GeocoderStatus.OK) { return; }

                    const gmaps = results[0];
                    const geoCodedLocation = gmaps.geometry.location;
                    suggestion.label = label;
                    suggestion.gmaps = gmaps;
                    suggestion.location = {
                        lat: geoCodedLocation.lat(),
                        lng: geoCodedLocation.lng()
                    };

                    this.props.onSuggestionSelect(suggestion);
                }
            );
        }
    }

    render() {
        const {
            className,
            size,
            value,
            placeholder,
            fixtures,
            types,
            country,
            onClear
        } = this.props;
        const classes = classNames(
            'GooglePlacesSearchInput',
            className
        );

        return (
            <div className={classes}>
                <AutoSuggestInput
                    ref="autosuggest"
                    placeholder={placeholder}
                    fixtures={fixtures}
                    size={size}
                    searchSuggestions={this._searchSuggestions}
                    onSuggestionSelect={this._onSuggestionSelect}
                    onClear={onClear}
                    autoActivateFirstSuggest
                    types={types}
                    country={country}
                    name="search_string"
                    initialValue={value}
                    icon="search"
                    showPoweredByGoogle
                />
            </div>
        );
    }
}

GooglePlacesSearchInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
    placeholder: PropTypes.string,
    focus: PropTypes.bool,
    onSuggestionSelect: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    fixtures: PropTypes.array,
    country: PropTypes.string,
    types: PropTypes.array,
    bounds: PropTypes.object
};

GooglePlacesSearchInput.defaultProps = {
    placeholder: 'Search Address or Venue',
    country: 'us',
    bounds: null
};

export default GooglePlacesSearchInput;



// WEBPACK FOOTER //
// ./spothero/static/main/js/search/components/common/GooglePlacesSearchInput.jsx